import React from "react";
import { useLocation } from "react-router-dom";
import SettingSider from "../components/Settings/SettingSider";
import ProfileSettings from "../components/Settings/ProfileSettings";
import QuotaSettings from "../components/Settings/QuotaSettings";
import BillingSetting from "../components/Settings/BillingSetting";

type Props = {};

const Settings = (props: Props) => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <section className="flex h-full min-h-0 flex-col overflow-hidden bg-background-grey px-4 pb-4 sm:px-6 sm:pb-6">
      <header className="shrink-0 py-6 pt-8">
        <h1 className="text-xl font-semibold text-dark-black">Settings</h1>
        <p className="mt-2 text-sm text-dark-grey">Manage your profile and account preferences</p>
      </header>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-[8px] border border-light-grey bg-white lg:flex-row">
        <div className="w-full shrink-0 overflow-x-auto border-b border-light-grey px-3 py-3 lg:max-w-[250px] lg:overflow-visible lg:border-b-0 lg:border-r lg:py-4">
          <SettingSider />
        </div>
        <div className="min-h-0 flex-1 overflow-auto px-4 py-4 sm:px-6 sm:py-5">
          {currentPath === "/settings/profile" && <ProfileSettings />}
          {currentPath === "/settings/account-activity" && <QuotaSettings />}
          {currentPath === "/settings/billing" && <BillingSetting />}
        </div>
      </div>
    </section>
  );
};

export default Settings;
